/**
 * ตั้งค่า sub-navigation — shared by the rail (which nests these under ตั้งค่า)
 * and the settings pages (breadcrumb + title).
 *
 * Order and paths taken from the live POS so a bookmarked settings URL lands in
 * the same place. `title` is the heading the page shows when it differs from
 * the menu label.
 */
export const SETTINGS_NAV = [
  { to: '/setting-general', label: 'ทั่วไป' },
  { to: '/setting-store', label: 'ข้อมูลร้าน' },
  { to: '/setting-product', label: 'บริการ' },
  { to: '/setting-promotion', label: 'โปรโมชั่น' },
  { to: '/setting-package', label: 'แพ็กเกจ' },
  { to: '/setting-staff', label: 'หมอนวด' },
  { to: '/setting-room', label: 'ห้องนวด' },
  { to: '/setting-customer', label: 'ลูกค้า' },
  { to: '/setting-bill', label: 'ใบเสร็จ', title: 'ใบเสร็จ/ใบกำกับภาษี' },
  { to: '/setting-booking-type', label: 'จอง/รับเงิน', title: 'ช่องทางการจอง/รับเงิน' },
  { to: '/setting-role', label: 'สิทธิ์เข้าใช้' },
];

export const isSettingsPath = (pathname) => pathname.startsWith('/setting');

export const settingsLabel = (pathname) => {
  const s = SETTINGS_NAV.find((x) => x.to === pathname);
  return s ? (s.title || s.label) : 'ตั้งค่า';
};
